(function () {
  "use strict";

  var MQ = window.matchMedia("(max-width: 749px)");
  var SLIDE_MS = 3000;
  var SLIDE_FIRST_MS = 1000;

  function qs(root, sel) {
    return root ? root.querySelector(sel) : null;
  }

  function qsa(root, sel) {
    return root ? Array.prototype.slice.call(root.querySelectorAll(sel)) : [];
  }

  function isOrientMode(overlay) {
    return (
      !!overlay &&
      overlay.getAttribute("data-uf-lf-color-preview-mode") === "orient"
    );
  }

  function resolveProductRoot(overlay) {
    if (isOrientMode(overlay)) {
      return (
        overlay.closest("[data-uf-orient]") ||
        overlay.closest(".uf-orient") ||
        document
      );
    }
    return (
      overlay.closest(".uf-lf-product") ||
      overlay.closest("[id^='uf-lf-product-']") ||
      document
    );
  }

  function getSourceSwatches(productRoot, overlay) {
    if (isOrientMode(overlay)) {
      var orientHost =
        qs(productRoot, "[data-uf-orient-color-swatches]") ||
        qs(productRoot, "[data-uf-lf-color-swatches]");
      if (!orientHost) return [];
      return qsa(orientHost, "a.uf-lf-color-swatch");
    }
    var host = qs(productRoot, "[data-uf-lf-color-swatches]");
    if (!host) return [];
    return qsa(host, "a.uf-lf-color-swatch");
  }

  function previewSrcFromSwatch(swatch) {
    if (!swatch) return "";
    var fromData = swatch.getAttribute("data-preview-src");
    if (fromData) return fromData;
    var img = qs(swatch, "img");
    return img ? img.getAttribute("src") || "" : "";
  }

  function parseImagesAttr(raw) {
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed
        .map(function (u) {
          return typeof u === "string" ? u : u && u.src ? String(u.src) : "";
        })
        .filter(Boolean);
    } catch (e) {
      return [];
    }
  }

  function galleryImagesFromOrient(productRoot) {
    var payload = qs(productRoot, "[data-uf-orient-preview-images]");
    if (payload) {
      try {
        var list = JSON.parse(payload.textContent || "[]") || [];
        return list
          .map(function (item) {
            if (!item) return null;
            if (typeof item === "string") return { src: item, alt: "" };
            return {
              src: item.src || "",
              srcset: item.srcset || "",
              alt: item.alt || "",
            };
          })
          .filter(function (item) {
            return item && item.src;
          });
      } catch (e) {}
    }
    var galleries = qsa(productRoot, "[data-uf-orient-gallery]");
    var gallery = null;
    for (var i = 0; i < galleries.length; i++) {
      var g = galleries[i];
      if (!g || !g.querySelector("img")) continue;
      var sheetOpen =
        productRoot.classList &&
        productRoot.classList.contains("is-product-sheet-open");
      var inDetail = !!(g.closest && g.closest("[data-uf-orient-detail-body], .uf-orient__detail-body, .uf-orient__overlay-pdp"));
      if (sheetOpen && inDetail) {
        gallery = g;
        break;
      }
      if (!sheetOpen && !gallery) gallery = g;
    }
    if (!gallery && galleries.length) gallery = galleries[0];
    if (!gallery) return [];
    var thumbs = qsa(gallery, ".uf-lf-gallery__thumb img");
    if (thumbs.length) {
      return thumbs
        .map(function (img) {
          return {
            src: img.currentSrc || img.getAttribute("src") || "",
            alt: img.getAttribute("alt") || "",
          };
        })
        .filter(function (item) {
          return item.src;
        });
    }
    var hero = qs(gallery, ".uf-lf-gallery__hero, [data-uf-orient-gallery-hero]");
    if (hero) {
      var src = hero.currentSrc || hero.getAttribute("src") || "";
      if (src) return [{ src: src, alt: hero.getAttribute("alt") || "" }];
    }
    return [];
  }

  function galleryImagesFromDom(productRoot, overlay) {
    if (isOrientMode(overlay)) {
      return galleryImagesFromOrient(productRoot);
    }
    var rootId = productRoot && productRoot.id ? String(productRoot.id) : "";
    var sectionId =
      rootId.indexOf("uf-lf-product-") === 0
        ? rootId.slice("uf-lf-product-".length)
        : "";
    var script = sectionId
      ? document.getElementById("uf-lf-images-" + sectionId)
      : qs(productRoot, 'script[id^="uf-lf-images-"]') ||
        qs(document, 'script[id^="uf-lf-images-"]');
    if (!script) return [];
    try {
      var list = JSON.parse(script.textContent || "[]") || [];
      return list
        .map(function (item) {
          if (!item) return null;
          if (typeof item === "string") return { src: item, alt: "" };
          return {
            src: item.src || "",
            srcset: item.srcset || "",
            alt: item.alt || "",
          };
        })
        .filter(function (item) {
          return item && item.src;
        });
    } catch (e) {
      return [];
    }
  }

  function heroSrc(productRoot) {
    var hero =
      qs(productRoot, "[data-uf-orient-gallery-hero]") ||
      qs(productRoot, ".uf-lf-gallery__hero");
    return hero ? hero.currentSrc || hero.getAttribute("src") || "" : "";
  }

  function orientApi() {
    return window.UF_ORIENT_COLOR_PREVIEW || null;
  }

  function initPreview(overlay) {
    if (!overlay || overlay.getAttribute("data-uf-lf-color-preview-ready")) return;
    overlay.setAttribute("data-uf-lf-color-preview-ready", "1");

    var orient = isOrientMode(overlay);
    var productRoot = resolveProductRoot(overlay);
    var panel = qs(overlay, "[data-uf-lf-color-preview-panel]");
    var img = qs(overlay, "[data-uf-lf-color-preview-img]");
    var tray = qs(overlay, ".uf-lf-color-preview__tray");
    var swatchHost = qs(overlay, "[data-uf-lf-color-preview-swatches]");
    var goBtn = qs(overlay, "[data-uf-lf-color-preview-go]");
    var prevBtn = qs(overlay, "[data-uf-lf-color-preview-prev]");
    var nextBtn = qs(overlay, "[data-uf-lf-color-preview-next]");
    var infoTitle = qs(overlay, "[data-uf-lf-color-preview-info-title]");
    var infoPrice = qs(overlay, "[data-uf-lf-color-preview-info-price]");
    var infoBullets = qs(overlay, "[data-uf-lf-color-preview-info-bullets]");
    var infoSpecs = qs(overlay, "[data-uf-lf-color-preview-info-specs]");
    var currentId = String(overlay.getAttribute("data-uf-current-id") || "");
    var currentUrl = overlay.getAttribute("data-uf-current-url") || "";
    var pendingUrl = currentUrl;
    var pendingId = currentId;
    var lastFocus = null;
    var openMode = "zoom";
    var slideItems = [];
    var slideIdx = 0;
    var slideTimer = null;
    var cachedFactsHtml = "";
    var cachedPriceHtml = "";
    var cachedTitle = "";
    var cachedOrientCtaHtml = "";
    var CHECK_SVG =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';

    function refreshCurrentFromDom() {
      currentId = String(overlay.getAttribute("data-uf-current-id") || "");
      currentUrl = overlay.getAttribute("data-uf-current-url") || "";
      pendingUrl = currentUrl;
      pendingId = currentId;
    }

    function stopSlideshow() {
      if (slideTimer) {
        clearTimeout(slideTimer);
        clearInterval(slideTimer);
        slideTimer = null;
      }
    }

    /**
     * @param {number} [firstDelayMs] — wachttijd vóór eerste wissel (bij nieuwe kleur: 1s).
     * Daarna altijd SLIDE_MS (3s) tot opnieuw een kleur gekozen wordt.
     */
    function startSlideshow(firstDelayMs) {
      stopSlideshow();
      if (slideItems.length < 2) return;
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        return;
      }
      var initial =
        typeof firstDelayMs === "number" ? firstDelayMs : SLIDE_MS;
      slideTimer = setTimeout(function () {
        showSlide(slideIdx + 1);
        slideTimer = setInterval(function () {
          showSlide(slideIdx + 1);
        }, SLIDE_MS);
      }, initial);
    }

    function syncNavVisibility() {
      var multi = slideItems.length > 1;
      if (prevBtn) prevBtn.hidden = !multi;
      if (nextBtn) nextBtn.hidden = !multi;
    }

    function showSlide(i) {
      if (!slideItems.length || !img) return;
      slideIdx = ((i % slideItems.length) + slideItems.length) % slideItems.length;
      var item = slideItems[slideIdx];
      img.src = item.src;
      if (item.srcset) img.setAttribute("srcset", item.srcset);
      else img.removeAttribute("srcset");
      if (item.alt != null) img.alt = item.alt;
    }

    function setSlides(items) {
      slideItems = (items || []).filter(function (it) {
        return it && it.src;
      });
      if (!slideItems.length) {
        var fallback = heroSrc(productRoot);
        if (fallback) slideItems = [{ src: fallback, alt: "" }];
      }
      slideIdx = 0;
      showSlide(0);
      syncNavVisibility();
      startSlideshow(SLIDE_FIRST_MS);
    }

    function readDecisionFacts() {
      var script =
        qs(overlay, "script[data-uf-lf-decision-facts]") ||
        qs(productRoot, "script[data-uf-lf-decision-facts]");
      if (!script) return [];
      try {
        var list = JSON.parse(script.textContent || "[]") || [];
        if (!Array.isArray(list)) return [];
        return list
          .filter(function (f) {
            return f && f.show !== false && (f.label || f.value);
          })
          .slice(0, 4);
      } catch (e) {
        return [];
      }
    }

    function factDisplayText(fact) {
      if (!fact) return "";
      var label = String(fact.label || "").trim();
      var value = String(fact.value || "").trim();
      if (label && value) return label + ": " + value;
      return label || value;
    }

    function buildFactsHtml(facts) {
      if (!facts || !facts.length) return "";
      var ul = document.createElement("ul");
      ul.className =
        "uf-lf-spec-bullets uf-lf-spec-bullets--compact uf-lf-color-preview__fact-list";
      ul.setAttribute("role", "list");
      facts.forEach(function (fact) {
        var text = factDisplayText(fact);
        if (!text) return;
        var li = document.createElement("li");
        li.className = "uf-lf-spec-bullets__item";
        if (fact.id === "kwaliteitsgarantie") {
          li.className += " uf-lf-spec-bullets__item--quality";
        }
        var icon = document.createElement("span");
        icon.className =
          "uf-lf-spec-bullets__icon uf-lf-spec-bullets__icon--check";
        icon.setAttribute("aria-hidden", "true");
        icon.innerHTML = CHECK_SVG;
        var span = document.createElement("span");
        span.className = "uf-lf-spec-bullets__label";
        span.textContent = text;
        li.appendChild(icon);
        li.appendChild(span);
        ul.appendChild(li);
      });
      return ul.children.length ? ul.outerHTML : "";
    }

    function cacheCardInfoFromPdp() {
      var titleEl = qs(productRoot, ".uf-lf-product__title");
      cachedTitle = titleEl ? (titleEl.textContent || "").trim() : "";
      var priceRow = qs(productRoot, ".uf-lf-product__price-row");
      cachedPriceHtml = priceRow ? priceRow.innerHTML : "";
      cachedFactsHtml = buildFactsHtml(readDecisionFacts());
      cachedOrientCtaHtml = "";
    }

    function cacheCardInfoFromOrient() {
      var api = orientApi();
      if (api && typeof api.getCardInfo === "function") {
        try {
          var info = api.getCardInfo() || {};
          cachedTitle = info.title || "";
          cachedPriceHtml = info.priceHtml || "";
          cachedFactsHtml = info.statsHtml || "";
          cachedOrientCtaHtml = info.ctaHtml || "";
          return;
        } catch (e) {}
      }
      var titleEl =
        qs(productRoot, ".uf-orient__overlay-sec--cta .uf-lf-product__title") ||
        qs(productRoot, ".uf-orient__buy .uf-lf-product__title") ||
        qs(productRoot, ".uf-lf-product__title");
      cachedTitle = titleEl ? (titleEl.textContent || "").trim() : "";
      cachedPriceHtml = "";
      cachedFactsHtml = "";
      cachedOrientCtaHtml = "";
    }

    function renderCardInfo(swatch, isSibling) {
      var title =
        (swatch && swatch.getAttribute("data-title")) ||
        (swatch && swatch.getAttribute("aria-label")) ||
        cachedTitle;
      if (infoTitle) {
        infoTitle.textContent = title || "";
        infoTitle.hidden = !title;
      }

      if (infoPrice) {
        if (orient) {
          /* Orient: keep current sheet calc price / savings — not sibling unit prices. */
          if (cachedPriceHtml) {
            infoPrice.innerHTML = cachedPriceHtml;
            infoPrice.hidden = false;
          } else {
            infoPrice.innerHTML = "";
            infoPrice.hidden = true;
          }
        } else if (isSibling) {
          var price = swatch ? swatch.getAttribute("data-price") || "" : "";
          var compare = swatch ? swatch.getAttribute("data-compare-price") || "" : "";
          if (price) {
            var html =
              '<span class="uf-lf-product__price">' + price + "</span>";
            if (compare) {
              html +=
                '<span class="uf-lf-product__compare">' + compare + "</span>";
            }
            infoPrice.innerHTML = html;
            infoPrice.hidden = false;
          } else if (cachedPriceHtml) {
            infoPrice.innerHTML = cachedPriceHtml;
            infoPrice.hidden = false;
          } else {
            infoPrice.innerHTML = "";
            infoPrice.hidden = true;
          }
        } else if (cachedPriceHtml) {
          infoPrice.innerHTML = cachedPriceHtml;
          infoPrice.hidden = false;
        } else {
          infoPrice.innerHTML = "";
          infoPrice.hidden = true;
        }
      }

      if (infoBullets) {
        if (cachedFactsHtml) {
          infoBullets.innerHTML = cachedFactsHtml;
          infoBullets.hidden = false;
        } else {
          infoBullets.innerHTML = "";
          infoBullets.hidden = true;
        }
      }

      if (infoSpecs) {
        if (orient && cachedOrientCtaHtml) {
          infoSpecs.innerHTML = cachedOrientCtaHtml;
          infoSpecs.hidden = false;
        } else {
          infoSpecs.innerHTML = "";
          infoSpecs.hidden = true;
        }
      }
    }

    function slidesFromSwatch(swatch, isSibling) {
      if (!isSibling) {
        var gallery = galleryImagesFromDom(productRoot, overlay);
        if (gallery.length) return gallery;
      }
      var fromAttr = parseImagesAttr(
        swatch ? swatch.getAttribute("data-preview-images") : ""
      );
      if (fromAttr.length) {
        return fromAttr.map(function (src) {
          return { src: src, alt: "" };
        });
      }
      var single = previewSrcFromSwatch(swatch);
      if (single) return [{ src: single, alt: "" }];
      if (!isSibling) {
        var hero = heroSrc(productRoot);
        if (hero) return [{ src: hero, alt: "" }];
      }
      return [];
    }

    function setPending(url, id, isSibling) {
      pendingUrl = url || currentUrl;
      pendingId = id != null && id !== "" ? String(id) : currentId;
      if (goBtn) {
        goBtn.disabled = !isSibling;
      }
    }

    function markSelection(selectedId) {
      qsa(swatchHost, "a.uf-lf-color-swatch").forEach(function (a) {
        var id = String(a.getAttribute("data-product-id") || "");
        var isOriginal = id === currentId;
        var isPreview = id === String(selectedId || "");
        a.classList.toggle("is-original", isOriginal);
        a.classList.toggle("is-preview-active", isPreview && !isOriginal);
        a.classList.toggle("is-current", isOriginal && isPreview);
        if (isPreview) {
          a.setAttribute("aria-current", isOriginal ? "page" : "true");
        } else {
          a.removeAttribute("aria-current");
        }
      });
    }

    function applySwatch(swatch) {
      if (!swatch) return;
      var id = String(swatch.getAttribute("data-product-id") || "");
      var href = swatch.getAttribute("href") || "";
      var isSibling = !!(id && id !== currentId);
      setSlides(slidesFromSwatch(swatch, isSibling));
      renderCardInfo(swatch, isSibling);
      setPending(isSibling ? href : currentUrl, id || currentId, isSibling);
      markSelection(id || currentId);
    }

    function cloneSwatches() {
      if (!swatchHost) return;
      var sources = getSourceSwatches(productRoot, overlay);
      swatchHost.innerHTML = "";
      if (!sources.length) {
        if (tray) tray.hidden = true;
        return;
      }
      if (tray) tray.hidden = false;
      sources.forEach(function (src) {
        var clone = src.cloneNode(true);
        clone.classList.remove("is-current");
        clone.removeAttribute("aria-current");
        var id = String(clone.getAttribute("data-product-id") || "");
        if (id === currentId) {
          clone.classList.add("is-original");
        }
        swatchHost.appendChild(clone);
      });
    }

    function canOpen() {
      if (orient) return true;
      return MQ.matches;
    }

    function open(mode) {
      if (!canOpen()) return;
      openMode = mode === "color" ? "color" : "zoom";
      lastFocus = document.activeElement;
      refreshCurrentFromDom();
      if (orient) cacheCardInfoFromOrient();
      else cacheCardInfoFromPdp();
      cloneSwatches();
      var currentSwatch =
        (swatchHost &&
          qs(
            swatchHost,
            'a.uf-lf-color-swatch[data-product-id="' + currentId + '"]'
          )) ||
        null;
      setSlides(slidesFromSwatch(currentSwatch, false));
      renderCardInfo(currentSwatch, false);
      setPending(currentUrl, currentId, false);
      markSelection(currentId);
      overlay.hidden = false;
      overlay.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("uf-lf-color-preview-open");
      if (openMode === "color" && swatchHost) {
        var first =
          qs(swatchHost, "a.uf-lf-color-swatch:not(.is-original)") ||
          qs(swatchHost, "a.uf-lf-color-swatch");
        if (first) first.focus();
      } else if (panel) {
        panel.focus();
      }
    }

    function close() {
      stopSlideshow();
      overlay.hidden = true;
      overlay.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("uf-lf-color-preview-open");
      setPending(currentUrl, currentId, false);
      if (lastFocus && typeof lastFocus.focus === "function") {
        try {
          lastFocus.focus();
        } catch (e) {}
      }
    }

    function go() {
      if (!pendingUrl && !pendingId) return;
      if (String(pendingId) === String(currentId) && pendingUrl === currentUrl) {
        return;
      }
      if (orient) {
        var api = orientApi();
        if (api && typeof api.navigateToSibling === "function") {
          try {
            api.navigateToSibling({
              productId: pendingId,
              url: pendingUrl,
            });
          } catch (e) {}
          close();
          return;
        }
        try {
          overlay.dispatchEvent(
            new CustomEvent("uf-lf-color-preview:navigate", {
              bubbles: true,
              detail: { productId: pendingId, url: pendingUrl },
            })
          );
        } catch (e2) {}
        close();
        return;
      }
      if (!pendingUrl || pendingUrl === currentUrl) return;
      window.location.href = pendingUrl;
    }

    function triggerOrientBuyAction(kind) {
      var sel =
        kind === "offerte"
          ? "[data-uf-orient-offerte-select]"
          : "[data-uf-orient-add-cart]";
      var btn =
        qs(productRoot, ".uf-orient__sheet-dock " + sel) ||
        qs(productRoot, ".uf-orient__overlay-sec--cta " + sel) ||
        qs(productRoot, ".uf-orient__buy " + sel) ||
        qs(productRoot, sel);
      if (btn && typeof btn.click === "function") {
        btn.click();
      }
    }

    productRoot.addEventListener("click", function (e) {
      var btn =
        e.target && e.target.closest
          ? e.target.closest("[data-uf-lf-color-preview-open]")
          : null;
      if (!btn || !productRoot.contains(btn)) return;
      if (btn.closest("[data-uf-lf-color-preview]") === overlay) return;
      e.preventDefault();
      open(btn.getAttribute("data-uf-lf-color-preview-open") || "zoom");
    });

    qsa(overlay, "[data-uf-lf-color-preview-close]").forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        close();
      });
    });

    if (goBtn) {
      goBtn.addEventListener("click", function (e) {
        e.preventDefault();
        go();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        showSlide(slideIdx - 1);
        startSlideshow();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        showSlide(slideIdx + 1);
        startSlideshow();
      });
    }

    if (swatchHost) {
      swatchHost.addEventListener("click", function (e) {
        var a = e.target.closest ? e.target.closest("a.uf-lf-color-swatch") : null;
        if (!a || !swatchHost.contains(a)) return;
        e.preventDefault();
        applySwatch(a);
      });
    }

    if (infoSpecs) {
      infoSpecs.addEventListener("click", function (e) {
        var atc =
          e.target.closest &&
          e.target.closest("[data-uf-lf-color-preview-orient-atc]");
        var off =
          e.target.closest &&
          e.target.closest("[data-uf-lf-color-preview-orient-offerte]");
        if (atc) {
          e.preventDefault();
          triggerOrientBuyAction("atc");
          return;
        }
        if (off) {
          e.preventDefault();
          triggerOrientBuyAction("offerte");
        }
      });
    }

    document.addEventListener("keydown", function (e) {
      if (overlay.hidden) return;
      if (e.key === "Escape") {
        e.preventDefault();
        close();
        return;
      }
      if (e.key === "ArrowLeft" && slideItems.length > 1) {
        e.preventDefault();
        showSlide(slideIdx - 1);
        startSlideshow();
      } else if (e.key === "ArrowRight" && slideItems.length > 1) {
        e.preventDefault();
        showSlide(slideIdx + 1);
        startSlideshow();
      }
    });

    function syncColorCta() {
      var has = getSourceSwatches(productRoot, overlay).length > 0;
      qsa(productRoot, '[data-uf-lf-color-preview-open="color"]').forEach(
        function (btn) {
          btn.hidden = !has;
        }
      );
    }

    productRoot.addEventListener("uf-lf-color-swatches:rendered", function () {
      syncColorCta();
      if (!overlay.hidden) {
        var selected =
          qs(swatchHost, "a.uf-lf-color-swatch.is-preview-active") ||
          qs(swatchHost, "a.uf-lf-color-swatch.is-original") ||
          null;
        var selectedId = selected
          ? String(selected.getAttribute("data-product-id") || currentId)
          : currentId;
        refreshCurrentFromDom();
        cloneSwatches();
        var again =
          qs(
            swatchHost,
            'a.uf-lf-color-swatch[data-product-id="' + selectedId + '"]'
          ) ||
          qs(
            swatchHost,
            'a.uf-lf-color-swatch[data-product-id="' + currentId + '"]'
          );
        if (again) applySwatch(again);
        else markSelection(currentId);
      }
    });

    syncColorCta();

    if (panel && !panel.hasAttribute("tabindex")) {
      panel.setAttribute("tabindex", "-1");
    }

    overlay._ufLfColorPreview = {
      open: open,
      close: close,
      syncColorCta: syncColorCta,
    };
  }

  function boot(scope) {
    qsa(scope || document, "[data-uf-lf-color-preview]").forEach(initPreview);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  window.UF_LF_COLOR_PREVIEW = {
    init: boot,
    open: function (mode, root) {
      var overlay = qs(
        root || document,
        "[data-uf-lf-color-preview]"
      );
      if (overlay && overlay._ufLfColorPreview) {
        overlay._ufLfColorPreview.open(mode || "color");
      }
    },
  };
})();
